// import the react components
import React, {useRef} from "react";
import ThemeOptions from "./../ui/side/theme-options";
import {useStateContext} from "./../context/";
import useOutsideAlerter from "./../context/outside-alerter";

// the side setting functional based component
const SideSetting = () => {
    const {side_setting, set_side_setting} = useStateContext();
    const reference = useRef(null);
    useOutsideAlerter(reference, () => set_side_setting(false));

    // return to the component data
    return (
        <div ref={reference} className={`fixed top-0 right-0 h-screen w-[85%] sm:w-[380px] bg-white/90 dark:bg-[#0d1117]/90 backdrop-blur-xl border-l border-gray-200 dark:border-gray-800 shadow-[0_10px_40px_rgba(0,0,0,0.15)] dark:text-gray-200 z-50 transition-all duration-300 ease-in-out ${side_setting ? "translate-x-0" : "translate-x-full"}`}>
            <div className="flex justify-between items-center p-4 ml-4">
                <h2 className="text-xl font-medium capitalize">settings</h2>
            </div>

            <div className="flex-col border-t-2 border-color dark:border-gray-700 p-4 ml-4">
                <h3 className="text-lg font-medium capitalize">theme options</h3>
                <ThemeOptions />
            </div>
        </div>
    );
};
export default SideSetting;